import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d83f2d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 평균 환급 금액 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 1,151만원 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 24년 12월 기준 금액 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 168만명의 사업자가 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 더낸세금을 이용하고 있습니다. ")
const _hoisted_7 = { class: "rolling-feedback first" }
const _hoisted_8 = { class: "rolling-feedback second" }

import { ref, onMounted } from 'vue'

import Text from '@/components/common/TextComponent.vue'
import { COLOR_SET, FONT_WEIGHT } from '@/styles/variables'

import { firstFeedbacks, secondFeedbacks, FeedbackProps } from '../constants/feedbacks'
import { setAnimationObserver } from '../libs/observer'
import FeedbackCard from './FeedbackCard.vue'


export default /*#__PURE__*/_defineComponent({
  name: 'LandingFeedback',
  setup(__props) {

_useCssVars(_ctx => ({
  "13093efd": (getTranslate(_unref(firstFeedbacks))),
  "63dd618a": (getTranslate(_unref(firstFeedbacks), true)),
  "2fe17346": (getTranslate(_unref(secondFeedbacks))),
  "688c4e9b": (getTranslate(_unref(secondFeedbacks), true))
}))

const wrapper = ref()
const showAnimation = ref(false)

const getTranslate = (target: FeedbackProps[], isMobile?: boolean) => {
  const cardWidth = isMobile ? 223 : 447
  const cardGap = isMobile ? 8 : 16
  const translateLength = -(cardWidth + cardGap) * target.length
  return `translateX(${translateLength}px)`
}

onMounted(() => {
  setAnimationObserver(wrapper.value, () => { showAnimation.value = true }, 0.2)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapper",
    ref: wrapper,
    class: "wrapper"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Text, {
        margin: "100px 0 0 0",
        "mobile-margin": "50px 0 0 0",
        size: "64px",
        "line-height": "1.25",
        "mobile-size": "30px",
        weight: _unref(FONT_WEIGHT).bold,
        class: _normalizeClass(["animation-show", { show: showAnimation.value }])
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["weight", "class"]),
      _createVNode(Text, {
        margin: "16px 0 0 0",
        "mobile-margin": "12px 0 0 0",
        size: "64px",
        "line-height": "1.25",
        "mobile-size": "30px",
        weight: _unref(FONT_WEIGHT).bold,
        color: _unref(COLOR_SET).blue01,
        class: _normalizeClass(["animation-show delay", { show: showAnimation.value }])
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["weight", "color", "class"]),
      _createElementVNode("div", {
        class: _normalizeClass(["tooltip animation-show delay", { show: showAnimation.value }])
      }, [
        _createVNode(Text, {
          size: "20px",
          "mobile-size": "12px",
          color: _unref(COLOR_SET).white
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["color"])
      ], 2),
      _createVNode(Text, {
        size: "36px",
        "mobile-size": "16px",
        class: _normalizeClass(["animation-show delay", { show: showAnimation.value }])
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Text, {
        size: "36px",
        "mobile-size": "16px",
        class: _normalizeClass(["animation-show delay", { show: showAnimation.value }])
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(firstFeedbacks), (item) => {
        return (_openBlock(), _createBlock(FeedbackCard, {
          key: item.id,
          feedback: item,
          class: "feedback-card"
        }, null, 8, ["feedback"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(firstFeedbacks), (item) => {
        return (_openBlock(), _createBlock(FeedbackCard, {
          key: item.id,
          feedback: item,
          class: "feedback-card"
        }, null, 8, ["feedback"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(secondFeedbacks), (item) => {
        return (_openBlock(), _createBlock(FeedbackCard, {
          key: item.id,
          feedback: item,
          class: "feedback-card"
        }, null, 8, ["feedback"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(secondFeedbacks), (item) => {
        return (_openBlock(), _createBlock(FeedbackCard, {
          key: item.id,
          feedback: item,
          class: "feedback-card"
        }, null, 8, ["feedback"]))
      }), 128))
    ])
  ], 512))
}
}

})